var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiCard',{staticClass:"report_wrapper"},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('ReportTitle')],1),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('ReportDateConfigure'),_c('ReportChart')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }